import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import NavigationLink from '../NavigationLink';

const NavigationNestedLinks = (props) => {
  const { page, selectedSlug } = props;
  
  // Return null if no data or empty pages array
  if (!page || !Array.isArray(page.pages) || page.pages.length === 0) {
    return null;
  }
  
  const renderNavigationLink = (item) => (
    <li key={item.slug} className="navigation__list-item--vertical">
      <NavigationLink
        extraClass="navigation__link navigation__link--nested"
        textExtraId={item.additionalId}
        textExtraClass={classNames(
          'navigation__link-text navigation__link-text--nested',
          item.additionalClass,
        )}
        name={item.name}
        pages={item.pages}
        url={item.url}
        openInNewWindow={item.openInNewWindow}
        selected={item.slug === selectedSlug}
      />
    </li>
  );
  
  const renderButton = (item) => (
    <li
      key={item.slug}
      className="navigation__list-item--vertical"
    >
      <button
        className={classNames('navigation__button', item.additionalClass)}
        id={item.additionalId}
        type="button"
      >
        {item.name}
      </button>
    </li>
  );
  
  return (
    <ul className="navigation__list">
      {page.pages.map((item) => 
        item.url ? renderNavigationLink(item) : renderButton(item)
      )}
    </ul>
  );
};

NavigationNestedLinks.defaultProps = {
  page: null,
  selectedSlug: '',
};

NavigationNestedLinks.propTypes = {
  page: PropTypes.shape({
    pages: PropTypes.arrayOf(PropTypes.shape({
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string,
      pages: PropTypes.array,
      openInNewWindow: PropTypes.bool,
      additionalClass: PropTypes.string,
      additionalId: PropTypes.string,
    })),
  }),
  selectedSlug: PropTypes.string,
};

export default NavigationNestedLinks;